
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/aktualnosci/strona/[strona]",
      function () {
        return require("private-next-pages/aktualnosci/strona/[strona].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/aktualnosci/strona/[strona]"])
      });
    }
  